import { Directive, forwardRef, Attribute, ElementRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[appValidateEqual]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidator), multi: true }
    ]
})
export class EqualValidator implements Validator {

    constructor() { }

    @Input()
    appValidateEqual: string;

    @Input()
    reverse: string;

    private get isReverse() {
        if (!this.reverse) { return false; }
        return this.reverse === 'true' ? true : false;
    }

    validate(control: AbstractControl): { [key: string]: any } {
        const value = control.value;

        const comparedElement = control.root.get(this.appValidateEqual);

        if (comparedElement && value !== comparedElement.value && !this.isReverse) {
            return {
                appValidateEqual: false
            };
        }

        if (comparedElement && value === comparedElement.value && this.isReverse) {
            delete comparedElement.errors['appValidateEqual'];
            if (!Object.keys(comparedElement.errors).length) { comparedElement.setErrors(null); }
        }

        if (comparedElement && value !== comparedElement.value && this.isReverse) {
            comparedElement.setErrors({
                appValidateEqual: false
            });
        }

        return null;
    }
}
